import { useEffect, useRef, useState } from 'react';
import type { RefObject } from 'react';
import { LeafletMap } from './leafletMap';
import type { LeafletMapListener } from './leafletMap';

export type UseLeafletMapResult = {
  containerRef: RefObject<HTMLDivElement | null>;
  map: LeafletMap | undefined;
};

export function useLeafletMap(listener: LeafletMapListener): UseLeafletMapResult {
  const containerRef = useRef<HTMLDivElement | null>(null);
  const listenerRef = useRef<LeafletMapListener>(listener);
  const [map, setMap] = useState<LeafletMap | undefined>(undefined);

  listenerRef.current = listener;

  useEffect(() => {
    const container = containerRef.current;
    if (!container) {
      return;
    }

    const leafletMap = new LeafletMap(
      {
        markerClicked: (markerId) => listenerRef.current.markerClicked(markerId),
        contextMenuItemClicked: (itemId, position) => listenerRef.current.contextMenuItemClicked(itemId, position),
      },
      container,
    );
    setMap(leafletMap);

    return () => {
      setMap(undefined);
      leafletMap.destroy();
    };
  }, []);

  return { containerRef, map };
}
